import React from 'react'

const HighlightText = ({text}) => {
  return (
    <span className='font-bold text-yellow-200  cursor-grab'>
    {" "}
      {text}
    </span>
  )
}

export default HighlightText